import React, { FC } from 'react';
import { PowerBIReportDescription } from '../lib/api/types/PowerBIReportDescription';
import { PowerBiActions } from '../redux/actions/powerBi';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { RootState } from '../redux/RootState';
import { Spinner } from './styled/Spinner';
import { LinkButton } from './styled/LinkButton';

export const PowerBiReportItem: FC<{
    report: PowerBIReportDescription;
}> = ({ report }) => {
    const selectedReportDescription = useSelector((state: RootState) => state.powerBi.currentReport);
    const reportLoaded = useSelector((state: RootState) => state.powerBi.reportLoaded);
    const dispatch = useDispatch();
    const isSelected = selectedReportDescription === report;
    const classNames = isSelected && reportLoaded ? 'selected' : '';
    return (
        <LI className={classNames} data-report-id={report.id}>
            {!isSelected ? (
                <LinkButton
                    className={classNames}
                    type="button"
                    onClick={() => dispatch(PowerBiActions.viewReport(report))}
                >
                    {report.name}
                </LinkButton>
            ) : (
                <span>{report.name}</span>
            )}
            {selectedReportDescription === report && !reportLoaded && <LoadingIndicator />}
        </LI>
    );
};

const LoadingIndicator = styled(Spinner)`
    position: absolute;
    top: 1em;
    right: 1em;
`;

const LI = styled.li`
    user-select: none;
    position: relative;
    transition: all 500ms;
    border-top-left-radius: 0.8em;
    border-bottom-left-radius: 0.8em;
    &.selected {
        background-color: ${(props) => props.theme.colors.secondary.backgroundColor};
        color: ${(props) => props.theme.colors.secondary.color};
        text-decoration: none;
    }
    padding: 0.7em;
    padding-right: 2em;
`;
